/**
 * Utilitaires timezone — EPIC-29 Story 29.1
 *
 * Tout reste en heure Paris (Europe/Paris).
 * Ces fonctions calculent uniquement le suffixe d'affichage GMT+X
 * sans effectuer de conversion de fuseau horaire.
 */

/**
 * Retourne le décalage GMT actuel de Europe/Paris (GMT+1 hiver, GMT+2 été).
 * Utilise Intl.DateTimeFormat pour obtenir le vrai décalage DST.
 */
export function getParisGMTOffset(): string {
  try {
    const now = new Date();
    const parts = new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'Europe/Paris',
      timeZoneName: 'short',
    }).formatToParts(now);
    const tzPart = parts.find(p => p.type === 'timeZoneName')?.value ?? 'UTC+1';
    // Normaliser : "UTC+1" → "GMT+1", "UTC+2" → "GMT+2"
    return tzPart.replace('UTC', 'GMT');
  } catch {
    // Fallback : hiver
    return 'GMT+1';
  }
}

/**
 * Retourne le label complet pour affichage sous les champs date/heure.
 * Exemple : "Heure de Paris (GMT+2)"
 */
export function getParisLabel(): string {
  return `Heure de Paris (${getParisGMTOffset()})`;
}
